import { render, staticRenderFns } from "./contactFollowModify.vue?vue&type=template&id=7b083f68&scoped=true&"
import script from "./contactFollowModify.vue?vue&type=script&lang=js&"
export * from "./contactFollowModify.vue?vue&type=script&lang=js&"
import style0 from "./contactFollowModify.vue?vue&type=style&index=0&id=7b083f68&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b083f68",
  null
  
)

export default component.exports